
import { styled } from '@mui/system';

export const Header = styled('div')({
    display: 'flex',
    flexDirection: 'row',
});

export const HeaderTitle = styled('div')(({ theme }) => ({
    color: '#fff',
    display: 'block',
    textAlign: 'center',
    width: 'fit-content',
    margin: '0 auto',
    fontWeight: '500',
    letterSpacing: '.1px',
    textShadow: '1px 1px 5px #777',
    [theme.breakpoints.down('md')]: {
        margin: '0 auto',
    },
}));

export const ContainerStyles = styled('div')(({ theme }) => ({
    padding: '0 100px',
    [theme.breakpoints.down('md')]: {
        padding: '0px',
    },
}));

export const Content = styled('div')(({ theme }) => ({
    display: 'inline-flex',
    width: '100%',
    gap: '12px',
    [theme.breakpoints.down('md')]: {
        display: 'block',
    },
}));

export const LoadingContainer = styled('div')({
    position: 'fixed',
    left: 'calc(50% - 25px)',
    top: 'calc(50% - 25px)',
});
